// extracted by mini-css-extract-plugin
export default {"page-title":"VideoUploadPage_page-title__YALwl","form":"VideoUploadPage_form__xoqNC","form-controllers-container":"VideoUploadPage_form-controllers-container__-9SnG"};